<template>
  <div>
    <Modal
      :open='isOpen'
      title='Verification'
      modal-classes='w-full max-w-3xl h-[80vh] p-0 absolute'
      title-classes='text-left border-b px-8 pt-5 pb-4'
      content-classes='flex-1 px-4 pt-5 bg-gray-50 overflow-y-auto pb-20'
      @close-modal='closeModal'
    >
      <template #content>
        <VerificationActionsList
          :key='actionResults'
          :action-results='actionResults'
          :verification-uuid='verificationStore.verificationUuid'
        />
      </template>
    </Modal>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import Modal from '@/components/Modal.vue'
  import { useVerificationStore } from '@/store/verification'
  import VerificationActionsList from '@/components/actions/CustomActions/Global/Verification/VerificationActionsList.vue'

  const verificationStore = useVerificationStore()

  const actionResults = computed(() => verificationStore.actionResults)
  const isOpen = computed(() => verificationStore.requiresVerification)

  const closeModal = () => {
    verificationStore.requiresVerification = false
    verificationStore.selectedMethodType = null
    verificationStore.selectedMethodName = null
  }

</script>
